import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DocumentSequenceAdminDTO } from '../../../types/settings/correlatives/DocumentSequenceAdminDTO';

const initialState: CorrelativesAdminState = {
    list: [],
    selected: null,
    showModal: false,
    isLoading: false,
    isSubmitting: false,
    errors: {},
};

const correlativesAdminSlice = createSlice({
    name: 'correlativesAdmin',
    initialState,
    reducers: {

        /* =======================
         * 📋 LISTA (TABLA)
         * ======================= */

        setCorrelativeList(state, action: PayloadAction<DocumentSequenceAdminDTO[]>) {
            state.list = action.payload;
        },

        /* =======================
     * 🔄 ACTUALIZAR ITEM (RESET)
     * ======================= */

        updateCorrelativeInList(
            state,
            action: PayloadAction<DocumentSequenceAdminDTO>
        ) {
            const index = state.list.findIndex(
                item => item.id === action.payload.id
            );

            if (index !== -1) {
                // 🔁 Reemplaza el item actualizado
                state.list[index] = action.payload;
            } else {
                // 🧩 Fallback (por si no estaba en la lista)
                state.list.unshift(action.payload);
            }
        },


        clearCorrelativeList(state) {
            state.list = [];
        },

        /* =======================
         * 🧾 SELECCIÓN / FORM
         * ======================= */

        setSelectedCorrelative(
            state,
            action: PayloadAction<DocumentSequenceAdminDTO | null>
        ) {
            state.selected = action.payload;
        },

        clearSelectedCorrelative(state) {
            state.selected = null;
        },

        /* =======================
         * 🪟 MODAL
         * ======================= */

        openCorrelativeModal(state) {
            state.showModal = true;
        },

        closeCorrelativeModal(state) {
            state.showModal = false;
            state.selected = null;
            state.errors = {};
        },

        /* =======================
         * ⏳ FLAGS
         * ======================= */

        setIsLoading(state, action: PayloadAction<boolean>) {
            state.isLoading = action.payload;
        },

        setIsSubmitting(state, action: PayloadAction<boolean>) {
            state.isSubmitting = action.payload;
        },

        /* =======================
         * ⚠️ ERRORES
         * ======================= */

        setErrors(state, action: PayloadAction<Record<string, string>>) {
            state.errors = action.payload;
        },

        clearErrors(state) {
            state.errors = {};
        },
    },
});

export const {
    setCorrelativeList,
    updateCorrelativeInList,
    clearCorrelativeList,
    setSelectedCorrelative,
    clearSelectedCorrelative,
    openCorrelativeModal,
    closeCorrelativeModal,
    setIsLoading,
    setIsSubmitting,
    setErrors,
    clearErrors,
} = correlativesAdminSlice.actions;

export default correlativesAdminSlice.reducer;
